import { SportsRequest, DateRange, EventsCountByTagRequest } from "sb-resp-lib";

export type SportBFFQueryFactory = () => SportsRequest;

export const preLiveSportBFFQueryFactoryConstructor = (dateFactory: DateConstructor) => {
    return () => ({
        eventState: SportsRequest.EventStateEnum.PreLive,
        dateRange: {
            from: new dateFactory(),
            timeRange: DateRange.TimeRangeEnum.SixHours,
        }
    });
}

export const liveSportBFFQueryFactory: SportBFFQueryFactory = () => {
    return {
        eventState: SportsRequest.EventStateEnum.Live,
    };
}

export type liveStreamingQueryFactory = () => EventsCountByTagRequest;
export type liveStreamingQueryFactoryWithDate = (from: Date) => EventsCountByTagRequest;

export const todayLiveStreamingQueryFactory: liveStreamingQueryFactoryWithDate = (from: Date) => preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.OneDay);
export const upcomingLiveStreamingQueryFactory: liveStreamingQueryFactoryWithDate = (from: Date) => preLiveLiveStreamingQueryFactory(from, DateRange.TimeRangeEnum.SixHours);
const preLiveLiveStreamingQueryFactory = (from: Date, range: DateRange.TimeRangeEnum): EventsCountByTagRequest => {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventState: EventsCountByTagRequest.EventStateEnum.PreLive,
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        dateRange: {
            from,
            timeRange: range
        }
    };
}

export const liveLiveStreamingQueryFactory: liveStreamingQueryFactory = () => {
    return {
        eventTags: [EventsCountByTagRequest.EventTagsEnum.LiveStreaming],
        eventTypes: [EventsCountByTagRequest.EventTypesEnum.Fixture],
        eventState: EventsCountByTagRequest.EventStateEnum.Live
    };
}

export type TodaySportBFFQueryFactory = (from: Date) => SportsRequest;
export const todaySportBFFQueryFactory : TodaySportBFFQueryFactory = (from: Date) : SportsRequest => {
    return {
        eventState: SportsRequest.EventStateEnum.Mixed,
        dateRange: {
            from,
            timeRange: DateRange.TimeRangeEnum.OneDay,
        }
    };
}